const POST_GRAPHQL_FIELDS = `
sys {
  id
}
url
h1
mere{
  h1
  url
  titleSmall
  alt
}
titleSmall
metaTitle
metaDescription
metaRobots
dateCreation
dateModification
intro
showZoneContact
zoneContact{
  json
}
btnContactText
contenu {
  json
  links {
    assets { 
      block {
        sys {
          id
        }
        url
        title
        width
        height
        description
        contentType
      }
    }
  }
}
blocsCollection(limit:5) {
  total
  items {
    titreShort
    texte {
      json
      links {
        assets  { 
          block {
            sys {
              id
            }
            url
            title
            width
            height
            description
            contentType
          }
        }
      }
    }
  } 
}
resume
breadcrumbs
fbTitle
fbDescription
fbImage
video
metaOgUrl
metaOgSection
metaTTitle
metaTDescription
metaTUrl
typePage
liensCollection{
  total
  items {
    h1
    url
  }
}
auteur{
  nom
  prenom
  texte{
    json
  }
  image{
    url
  }
  facebook
  twitter
  linkedin
}
titreEnSavoirPlus
soustitreEnSavoirPlus
marquesBox
titleMarques
subtitleMarques
limitMarques
marquesCollection{
  total
  items {
    nom
    image{
      url
    }
    alt
  }
}
showReference
referenceTitle
referenceSubtitle
referenceToShow
`


const POST_GRAPHQL_FIELDS_LIST = `
url
titleSmall
alt
h1
dansMenu
ordre
mere{
  h1
  url
  titleSmall
  alt
}
titleSmall
metaTitle
metaDescription
metaRobots
dateCreation
dateModification
intro

image{
  title
  url
}
fbImage


`
// import sgMail from '@sendgrid/mail'

async function fetchGraphQL(query, preview = false) {
  return fetch(
    `https://graphql.contentful.com/content/v1/spaces/${process.env.CONTENTFUL_SPACE_ID}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${
          preview
            ? process.env.CONTENTFUL_PREVIEW_ACCESS_TOKEN
            : process.env.CONTENTFUL_ACCESS_TOKEN
        }`,
      },
      body: JSON.stringify({ query }),
    }
  ).then((response) => response.json())
}

function extractPost(fetchResponse) {
  //console.log(fetchResponse)
  return fetchResponse?.data?.articleCollection?.items?.[0]
}

function extractPostEntries(fetchResponse) {
  //console.log(fetchResponse)
  return fetchResponse?.data?.articleCollection?.items
}

function extractMarquesEntries(fetchResponse) {
  return fetchResponse?.data?.marqueCollection?.items
}

export async function getPreviewPostBySlug(slug) {
  const entry = await fetchGraphQL(
    `query {
      articleCollection(where: { url: "${slug}" , 
        contentfulMetadata: {
          tags_exists: true
          tags: {
              id_contains_some: ["${process.env.CONTENTFUL_SITE_TAG}"]
          }
        } 
      }, preview: true, limit: 1) {
        items {
          ${POST_GRAPHQL_FIELDS}
        }
      }
    }`,
    process.env.NODE_ENV == "development" ? true : false
  )
  return extractPost(entry)
}

export async function getAllPostsWithSlug() {
  const entries = await fetchGraphQL(
    `query {
      articleCollection(where: { url_exists: true, url_not: "/",
        contentfulMetadata: {
          tags_exists: true
          tags: {
              id_contains_some: ["${process.env.CONTENTFUL_SITE_TAG}"]
          }
        } 
      },
      preview: ${process.env.NODE_ENV == "development" ? 'true' : 'false'}
      , order: dateCreation_DESC) {
        items {
          url
        }
      }
    }`,
    process.env.NODE_ENV == "development" ? true : false
  )


  return extractPostEntries(entries)
}

export async function getAllSlug() {
  const entries = await fetchGraphQL(
    `query {
      articleCollection(where: { url_exists: true, 
        contentfulMetadata: {
          tags_exists: true
          tags: {
              id_contains_some: ["${process.env.CONTENTFUL_SITE_TAG}"]
          }
        } 
      },
      preview: ${process.env.NODE_ENV == "development" ? 'true' : 'false'}
      , order: dateCreation_DESC) {
        items {
          url
        }
      }
    }`,
    process.env.NODE_ENV == "development" ? true : false
  )
  return extractPostEntries(entries)
}

export async function getAllMarques() {
  const entries = await fetchGraphQL(
    `query {
      marqueCollection(where: { nom_exists: true, 
        contentfulMetadata: {
          tags_exists: true
          tags: {
              id_contains_some: ["${process.env.CONTENTFUL_SITE_TAG}"]
          }
        } 
      },
      preview: ${process.env.NODE_ENV == "development" ? 'true' : 'false'}
      , order: ordre_ASC) {
        items {
          titre
          nom
          image{
            url
          }
          alt
          afficheInReference
          description{
            json
          }
          imageDescription{
            url
          }
        }
      }
    }`,
    process.env.NODE_ENV == "development" ? true : false
  )
  return extractMarquesEntries(entries)
}

export async function getAllPostsForHome(preview) {
  const entries = await fetchGraphQL(
    `query {
      articleCollection(order: dateCreation_DESC, where: { typePage: "article", 
        contentfulMetadata: {
          tags_exists: true
          tags: {
              id_contains_some: ["${process.env.CONTENTFUL_SITE_TAG}"]
          }
        }  
      },
      preview: ${process.env.NODE_ENV == "development" ? 'true' : 'false'}
      , limit: 8) {
        items {
          ${POST_GRAPHQL_FIELDS_LIST}
        }
      }
    }`,
    process.env.NODE_ENV == "development" ? true : false
  )
  const exempleEntries = await fetchGraphQL(
    `query {
      articleCollection(order: dateCreation_DESC, where: { typePage: "exemple", 
        contentfulMetadata: {
          tags_exists: true
          tags: {
              id_contains_some: ["${process.env.CONTENTFUL_SITE_TAG}"]
          }
        }  
      },
      preview: ${process.env.NODE_ENV == "development" ? 'true' : 'false'}
      ) {
        items {
          ${POST_GRAPHQL_FIELDS_LIST}
        }
      }
    }`,
    process.env.NODE_ENV == "development" ? true : false
  )

  return {
    
    articles: extractPostEntries(entries),
    exemples: extractPostEntries(exempleEntries),
  }
}


export async function getArticleByType(type, preview) {
  const entries = await fetchGraphQL(
    `query {
      articleCollection(order: dateCreation_DESC, where: { typePage: "${type}", 
        contentfulMetadata: {
          tags_exists: true
          tags: {
              id_contains_some: ["${process.env.CONTENTFUL_SITE_TAG}"]
          }
        }  
      },
      preview: ${process.env.NODE_ENV == "development" ? 'true' : 'false'}
      ) {
        items {
          ${POST_GRAPHQL_FIELDS_LIST}
        }
      }
    }`,
    process.env.NODE_ENV == "development" ? true : false
  )
  return extractPostEntries(entries)
}

export async function getBreadcrumbs(url, preview){
  //console.log('getBreadcrumbs url', url);
  let tabMere = [];
  let urlTemp = '/' + url;

  while(urlTemp != null){
    const entries = await fetchGraphQL(
      `query {
        articleCollection(order: dateCreation_DESC, where: { url: "${urlTemp}"
          
        },
        preview: ${process.env.NODE_ENV == "development" ? 'true' : 'false'}
        ) {
          items {
            ${POST_GRAPHQL_FIELDS_LIST}
            }
          }
        
      }`,
      process.env.NODE_ENV == "development" ? true : false
    )
    let temptab = await extractPost(entries)

    tabMere.push(temptab);
    if(temptab?.mere && temptab.mere.url){
      urlTemp = temptab.mere.url
    }else{
      urlTemp = null;
    }
    //console.log('fin while urlTemps', urlTemp);

  }
  tabMere.reverse()
  return tabMere;
}

export async function getDaughter(url, preview){
  
  let where
  if(url == '') where = "mere_exists : false,  dansMenu_not : false, url_exists : true "
  else where = 'mere:{ url: "'+url+'",  dansMenu_not : false, url_exists : true  }'
 
  
  const entries = await fetchGraphQL(
    `query {
      articleCollection(order: [ordre_ASC, dateCreation_DESC], where: { 
        ${where},
        contentfulMetadata: {
          tags_exists: true
          tags: {
              id_contains_some: ["${process.env.CONTENTFUL_SITE_TAG}"]
          }
        }  
      },
      preview: ${process.env.NODE_ENV == "development" ? 'true' : 'false'}
      ) {
        items {
           ${POST_GRAPHQL_FIELDS_LIST}
        }
      }
    }`,
    process.env.NODE_ENV == "development" ? true : false
  )
  return await extractPostEntries(entries)
}



export async function getMotherAndSister(url, preview){
  let result = {};
  
  //On prend la metre
  url = '/' + url;
  const entries = await fetchGraphQL(
    `query {
      articleCollection(order: dateCreation_DESC, where: { url: "${url}"
        
      },
     
      preview: ${process.env.NODE_ENV == "development" ? 'true' : 'false'}
      ) {
        items {
          ${POST_GRAPHQL_FIELDS_LIST}
          }
        }
      
    }`,
    process.env.NODE_ENV == "development" ? true : false
  )
  
  let rep = await extractPost(entries)
  result.mother = rep?.mere
  let urlMere = rep?.mere?.url // .substr(1) ?? ''

  

  // On cherche les filles de la mère  
  result.sister =  await getDaughter(urlMere, preview)



  // On cherche la suivante et la précédente 
  result.previous = null;
  result.next = null;

  let find = false;
  let previousTemp = null;
  result.sister.map((element, index) => {
    //console.log('element', element)
    if(find == true && result.next == null ){
      result.next = element
    }
    if(element.url == url){
      find = true
      result.previous = previousTemp
    }
    previousTemp = element

  })  


  //console.log('result', result)
  return result
}



export async function getPostAndMorePosts(url, preview) {
  const entry = await fetchGraphQL(
    `query {
      articleCollection(where: { url: "/${url}", 
        contentfulMetadata: {
          tags_exists: true
          tags: {
              id_contains_some: ["${process.env.CONTENTFUL_SITE_TAG}"]
          }
        }  
      },
      preview: ${process.env.NODE_ENV == "development" ? 'true' : 'false'}
      , limit: 1) {
        items {
          ${POST_GRAPHQL_FIELDS}
        }
      }
    }`,
    process.env.NODE_ENV == "development" ? true : false
  )
  /* const entries = await fetchGraphQL(
    `query {
      articleCollection(where: { url_not_in: "/${url}" , 
        contentfulMetadata: {
          tags_exists: true
          tags: {
              id_contains_some: ["${process.env.CONTENTFUL_SITE_TAG}"]
          }
        } 
      }, order: dateCreation_DESC,
      preview: ${process.env.NODE_ENV == "development" ? 'true' : 'false'}
      , limit: 2) {
        items {
          ${POST_GRAPHQL_FIELDS}
        }
      }
    }`,
    process.env.NODE_ENV == "development" ? true : false
  ) */
  return {
    article: extractPost(entry),
    moreArticle: [],
  }
  
}

export async function sendMessageApi(req, siteEnv) {
  if (!req.email.value) {
    return {erreur : "Erreur : mail manquant"};
  }
  if (!req.name.value/*  || !req?.firstName?.value */) {
    return {erreur : "Erreur : nom manquant"};
  }
  if (!req.message.value) {
    return {erreur : "Erreur : message manquant"};
  }
  console.log(req.email.value);
  const msg = {
    email: req.email.value,
    name: /* req.firstName.value + ' ' + */ req.name.value,
    tel: req.tel.value,
    message: req.message.value,
    siteEnv
  };
  console.log(msg);
  return fetch(
    `https://api.alphalives.com/envoi_message_pwa`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
       // Authorization: `Bearer ${process.env.CONTENTFUL_ACCESS_TOKEN}`,
      },
      body: JSON.stringify({ msg }),
    }
  ).then((response) => response.json());
  /* try {
    await sgMail.send(msg);
    return 'message envoyé';
  } catch (error) {
    return 'Erreur lors de l\'envoi du mail';
  } */
}


